import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import _ from 'lodash';
import { Container, Segment, Header, Table, List, Popup, Label } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

import { getUserDisplayNameFromEmail } from '../../../helpers/format';
import { base } from '../../../config/constants';

const getUserLabelContent = (email) => {
  if (!email) {
    return null;
  }
  return (
    <Popup
      trigger={
        <Header
          content={getUserDisplayNameFromEmail(email)}
          size="tiny"
        />
      }
    >
      <Popup.Content>{email}</Popup.Content>
    </Popup>
  );
};

const getTypeLabel = (habilitations) => {
  if (!habilitations) {
    return '';
  }
  if (habilitations && habilitations.superuser) {
    return (<Label color="red">Super Administrateur</Label>);
  }
  if (habilitations) {
    return (<Label color="blue">Émetteur</Label>);
  }
  return 'N/A';
};

const getFormattedList = (themes) => {
  if (!themes || Object.keys(themes).length < 1) {
    return '-';
  }

  const themesList = Object.keys(themes);

  return (
    <Popup
      trigger={<Label>{themesList.length}</Label>}
      position="right center"
      // inverted
    >
      <List>
        {
          _.map(themesList, theme => (
            <List.Item key={theme}>
              <List.Content>
                {theme.toUpperCase()}
              </List.Content>
            </List.Item>
          ))
        }
      </List>
    </Popup>
  );
};

export default class ListAdmins extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // selectedAdmin: null,
      adminsLoading: true,
      admins: [],
    };
  }

  componentDidMount() {
    base.bindToState('administrateurs', {
      context: this,
      state: 'admins',
      asArray: true,
      queries: {
        orderByChild: 'email',
        // limitToLast: 3
      },
      then: () => this.setState({ adminsLoading: false }),
    });
  }

  render() {
    // console.log('admins', this.state.admins);
    return (
      <Container>
        <Segment basic loading={this.state.adminsLoading}>
          <Table
            compact
            selectable
            stackable
            // sortable
            tableData={this.state.admins}
            headerRow={
              <Table.Row>
                <Table.HeaderCell>
                  Identifiant
                </Table.HeaderCell>
                <Table.HeaderCell>Type</Table.HeaderCell>
                <Table.HeaderCell>Professions</Table.HeaderCell>
                <Table.HeaderCell>Communes</Table.HeaderCell>
                <Table.HeaderCell>Circonscriptions</Table.HeaderCell>
              </Table.Row>
            }
            footerRow={this.state.admins.length === 0 ?
              (
                <Table.Row>
                  <Table.Cell colSpan={5} textAlign="center" disabled>
                    <Segment basic padded="very">
                      Aucun administrateur ne peut être affiché
                    </Segment>
                  </Table.Cell>
                </Table.Row>
              ) : null}
            renderBodyRow={data => (
              <Table.Row key={data.key}>
                <Table.Cell>
                  <Link to={`/access-mgt/view/${data.key}`}>
                    {getUserLabelContent(data.email)}
                  </Link>
                </Table.Cell>
                <Table.Cell>
                  <Link to={`/access-mgt/view/${data.key}`}>
                    {getTypeLabel(data.habilitations)}
                  </Link>
                </Table.Cell>
                <Table.Cell>
                  <Link to={`/access-mgt/view/${data.key}`}>
                    {data.habilitations ? getFormattedList(data.habilitations.themes) : null}
                  </Link>
                </Table.Cell>
                <Table.Cell>
                  <Link to={`/access-mgt/view/${data.key}`}>
                    {data.habilitations ? getFormattedList(data.habilitations.citizenly) : null}
                  </Link>
                </Table.Cell>
                <Table.Cell>
                  <Link to={`/access-mgt/view/${data.key}`}>
                    {data.habilitations ? getFormattedList(data.habilitations.elected) : null}
                  </Link>
                </Table.Cell>
              </Table.Row>
            )}
          />
        </Segment>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/protected/AccessManagement/ListAdmins.js